import api from '../../helpers/api';
import {
    IGetOpponentsPayload,
    IOpponentSearchBarState,
} from './OpponentSearchBar-types';
import Router from '../../router';
import { IUserPayload } from '../Users/Users-types';

const opponentSearchBar: IOpponentSearchBarState = {
    state: {
        currentPage: 1,
        loaded: false,
        opponents: [],
        pages: [],
        username: '',
    },
    mutations: {
        setOpponents(state, opponents: IUserPayload[]) {
            state.opponents = opponents;
        },
        setOpponentsLoaded(state, loaded: boolean) {
            state.loaded = loaded;
        },
        setPages(state, pages: number[]) {
            state.pages = pages;
        },
        setCurrentPage(state, currentPage: number) {
            state.currentPage = currentPage;
        },
        setOpponentUsername(state, username: string) {
            state.username = username;
        },
    },
    actions: {
        async getOpponents({ commit }, options: IGetOpponentsPayload) {
            commit('setOpponentsLoaded', false);
            commit('setCurrentPage', options.page);

            const { page, userUuid, opponentUsername } = options;

            const url = `/user/${userUuid}/opponents/?opponentUsername=${opponentUsername}&page=${page}`;

            const response = await api.request(url, 'GET');
            const responseData = await response.json();

            if (response.ok) {
                const opponents = responseData.users;
                commit('setOpponents', opponents);
                commit('setOpponentsLoaded', true);
            }

            if (response.status === 401) {
                Router.push({ name: 'login' });
            }
        },
        setOpponents({ commit }, opponents: IUserPayload[]) {
            commit('setOpponents', opponents);
        },
        setOpponentsLoaded({ commit }, loaded: boolean) {
            commit('setOpponentsLoaded', loaded);
        },
        setOpponentUsername({ commit }, username: string) {
            commit('setOpponentUsername', username);
        },
    },
};

export default opponentSearchBar;
